import { useCallback } from 'react';

const useScheduleTableActions = (
  selectedRows,
  setSelectedRows,
  data,
  batchUpdateSchedules,
  match,
  targetId,
  targetType,
  fetchSchedules,
  onDelete,
  setConfirmationModalVisible,
) => {
  const handleMoveToRental = useCallback(async () => {
    const selectedItems = selectedRows.map((idx) => data[idx]);
    await batchUpdateSchedules(
      match.params.token,
      selectedItems,
      'group',
      'investment_properties_owned',
      targetId,
      targetType,
    );
    setSelectedRows([]);
    fetchSchedules(match.params.token);
  }, [selectedRows, data, batchUpdateSchedules, match.params.token,
    targetId, targetType, setSelectedRows, fetchSchedules]);

  const handleMoveToBridge = useCallback(async () => {
    const selectedItems = selectedRows.map((idx) => data[idx]);
    await batchUpdateSchedules(
      match.params.token,
      selectedItems,
      'group',
      'fix_and_flips',
      targetId,
      targetType,
    );
    setSelectedRows([]);
    fetchSchedules(match.params.token);
  }, [selectedRows, data, batchUpdateSchedules, match.params.token,
    targetId, targetType, setSelectedRows, fetchSchedules]);

  const handleMoveToPrimary = useCallback(async () => {
    const selectedItems = selectedRows.map((idx) => data[idx]);
    await batchUpdateSchedules(
      match.params.token,
      selectedItems,
      'group',
      'primary_residence',
      targetId,
      targetType,
    );
    setSelectedRows([]);
    fetchSchedules(match.params.token);
  }, [selectedRows, data, batchUpdateSchedules, match.params.token,
    targetId, targetType, setSelectedRows, fetchSchedules]);


  const handleMoveToNewConstruction = useCallback(async () => {
    const selectedItems = selectedRows.map((idx) => data[idx]);
    await batchUpdateSchedules(
      match.params.token,
      selectedItems,
      'group',
      'new_construction',
      targetId,
      targetType,
    );
    setSelectedRows([]);
    fetchSchedules(match.params.token);
  }, [selectedRows, data, batchUpdateSchedules, match.params.token,
    targetId, targetType, setSelectedRows, fetchSchedules]);

  const handleMoveToBridgeRent = useCallback(async () => {
    const selectedItems = selectedRows.map((idx) => data[idx]);
    await batchUpdateSchedules(
      match.params.token,
      selectedItems,
      'group',
      'fix_and_rent',
      targetId,
      targetType,
    );
    setSelectedRows([]);
    fetchSchedules(match.params.token);
  }, [selectedRows, data, batchUpdateSchedules, match.params.token,
    targetId, targetType, setSelectedRows, fetchSchedules]);

  const handleNotMine = useCallback(() => {
    if (selectedRows.length > 0) {
      setConfirmationModalVisible(true);
    }
  }, [selectedRows.length, setConfirmationModalVisible]);

  const handleConfirmNotMine = useCallback(async () => {
    const selectedItems = selectedRows.map((idx) => data[idx]);

    try {
      await Promise.all(selectedItems.map((item) => onDelete(item)));
      setConfirmationModalVisible(false);
      await fetchSchedules(match.params.token);
      setSelectedRows([]);
    } catch (error) {
      setConfirmationModalVisible(false);
    }
  }, [selectedRows, data, onDelete, setConfirmationModalVisible, fetchSchedules,
    match.params.token, setSelectedRows]);

  return {
    handleMoveToRental,
    handleMoveToBridge,
    handleMoveToPrimary,
    handleMoveToNewConstruction,
    handleMoveToBridgeRent,
    handleNotMine,
    handleConfirmNotMine,
  };
};

export default useScheduleTableActions;
